import React from "react";
import "./TourPopup.css";
import { Height } from "@mui/icons-material";
import { IP } from "../internalServer"

const HomePageTourPopup = ({
  setStepsEnabled,
  setHomeScreenWalkThroughPopup,
  Student_Id
}) => {
  // let Student_Id = JSON.parse(localStorage.getItem("breathForStudent"));
  return (
    <div className="ContainerSubmitedSucess">
      <div className="SubContainerSubmitedSucess innerContainerFlex" style={{ width: "50%" }}>
        <div className="imageContainer">
          <img src="/gif/welcome_login.gif" alt="" />
        </div>
        <div className="rightContainer">
          <div className="studentLogos leftMargin">
            {<img
              src={
                Student_Id?.profile_picture
                  ? IP + Student_Id?.profile_picture.replace(/^\./, "")
                  : Student_Id?.gender === "M"
                    ? Student_Id?.avatar_profile ? '/images/Boys/' + Student_Id?.avatar_profile + '.webp'
                      : "/images/Student_boy_pic.png"
                    : Student_Id?.gender === "F"
                      ? Student_Id?.avatar_profile ? '/images/Girls/' + Student_Id?.avatar_profile + '.webp'
                        : "/images/Student_girl_pic.png"
                      : "/images/default image.png"
              }
              alt="icon"
              className="prifilePicImg"
              style={{ width: "50px", height: "50px", borderRadius: "50%" }}
              onError={(e) => {
                if (Student_Id?.gender === "M") {
                  e.target.src = Student_Id?.avatar_profile ? '/images/Boys/' + Student_Id?.avatar_profile + '.webp' : "/images/Student_boy_pic.png"
                } else if (Student_Id?.gender === "F") {
                  e.target.src = Student_Id?.avatar_profile ? '/images/Girls/' + Student_Id?.avatar_profile + '.webp' : "/images/Student_girl_pic.png"
                } else {
                  e.target.src = "/images/default image.png"
                }
              }}
            />}
            <div>
              <img
                src="/StudentImg/BreathSchoolLogo.png"
                alt="icon"
                width={"30px"}
              ></img>
            </div>
          </div>
          <div className=" overallMarginHead" >
            <h2 className="textColor1"> Hi {Student_Id.name},</h2>
          </div>

          <div className=" overallMargin1">
            <h3 className="textColor1"> B4s Welcomes you!</h3>
            <h3 className="textColor1"> Glad to see you 😊</h3>
          </div>

          <div className=" overallMargin" style={{ scrollbarWidth: "none", height: "10vh" }}>
            <h5 className="textColor2">
              Please have a product tour for better understanding.
            </h5>
          </div>

          <div className="buttonsContainer" style={{ gap: "45px" }}>
            <button
              className="leftBtn"
              onClick={() => setHomeScreenWalkThroughPopup(false)}
            >
              Skip the product tour
            </button>
            <button
              className="rightBtn"
              id="dashboardtour"
              onClick={() => {
                setHomeScreenWalkThroughPopup(false);
                setStepsEnabled(true);
              }}
            >
              Sure, take me to product tour
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePageTourPopup;
